export const PayrollApiUrls = {
  careHomePayrolls: '/care-homes/$chId/payroll-adjustment',
  payrolls: '/payroll-adjustment',
};
